export default __webpack_public_path__ + "static/media/header-full.92ded709.jpg";